import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../config";
import { triggerNotification } from "../../../component/message/Msg";
import Spinner from "../../../component/loadingbar/Spinner";
// import noImg from "../../../assetsCon/assets/images/icons/no-image.png";

const ViewEmployee = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = config.token;
  const [loading, setLoading] = useState(false);

  const [employeeData, setEmployeeData] = useState({});

  //---------------------------------------- get / read employee -------------------------------------------R
  const fetchEmployeeData = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}sales/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            const responseData = data.data;
            console.log(responseData);
            await setEmployeeData(responseData);
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id !== undefined) {
      fetchEmployeeData(id);
    }
  }, [id]);

  return (
    <>
      <Breadcrumb
        txt="Manage Employee"
        subpath={["View Employees", "Employee Details"]}
        url={["/viewemployees"]}
      />

      {loading ? (
        <Spinner />
      ) : (
        <div className="container-xxl flex-grow-1 container-p-y mt-12">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                  <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
                    <img
                      src={employeeData.profile}
                      alt="employee image"
                      className="d-block h-[7.5rem] ms-0 ms-sm-4 border-white rounded user-profile-img"
                      // srcset={noImg}
                    />
                  </div>
                  <div className="flex-grow-1 mt-3 mt-sm-5">
                    <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                      <div className="user-profile-info">
                        <h4>
                          {employeeData.first_name +
                            " " +
                            employeeData.last_name}
                        </h4>
                        <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                          <li className="list-inline-item">
                            <i className="mdi mdi-account  form-icon me-1 mdi-20px"></i>
                            <span className="fw-medium">
                              {employeeData.username}
                            </span>
                          </li>
                          <li className="list-inline-item">
                            <i className="mdi mdi-map-marker-outline me-1 mdi-20px"></i>
                            <span className="fw-medium">
                              {employeeData.address}
                            </span>
                          </li>
                          <li className="list-inline-item">
                            <i className="mdi mdi-calendar-blank-outline me-1 mdi-20px"></i>
                            <span className="fw-medium">
                              Joined{" "}
                              {employeeData.hiredate &&
                                employeeData.hiredate.split("T")[0]}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-4">
            <div className="card-body row">
              <div className="col-md-6">
                <small className="card-text text-uppercase">About</small>
                <ul className="list-unstyled my-3 py-1">
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Full Name:</span>{" "}
                    <span>
                      {employeeData.first_name + " " + employeeData.last_name}
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-tie-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Employee Type:</span>{" "}
                    <span>{employeeData.sales_emp_type}</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-gift-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Incentive:</span>{" "}
                    <span>{employeeData.incentive}</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-group-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">
                      Parent employee:
                    </span>{" "}
                    <span>
                      {employeeData.perent_first_name +
                        " " +
                        employeeData.perent_first_name}
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-map-marker-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Address:</span>{" "}
                    <span>{employeeData.address}</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-cake mdi-24px"></i>
                    <span className="fw-medium mx-2">DOB:</span>{" "}
                    <span>
                      {employeeData.hiredate && employeeData.dob.split("T")[0]}
                    </span>
                  </li>
                </ul>

                <small className="card-text text-uppercase">Courses</small>
                <ul className="list-unstyled mb-0 my-3 py-1">
                  {employeeData?.courses?.map((crs) => (
                    <li
                      key={crs.course_id}
                      className="d-flex mb-2 pb-1"
                      // onClick={() => {
                      //   const encodedId = window.btoa(
                      //     encodeURIComponent(crs.course_id)
                      //   );
                      //   navigate(`/viewcourse/${encodedId}`);
                      // }}
                    >
                      <div className="avatar flex-shrink-0 me-3">
                        <span className="avatar-initial rounded bg-label-primary border-2">
                          <img
                            src={crs.image_link}
                            className="mdi mdi-video-outline mdi-24px rounded"
                            alt="chapter"
                          />
                        </span>
                      </div>
                      <div className="row w-100 align-items-center">
                        <div className="col-sm-8 col-lg-12 col-xxl-8 mb-1 mb-sm-0 mb-lg-1 mb-xxl-0">
                          <h6 className="mb-0 lh-sm">{crs.course_name}</h6>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-md-6">
                <small className="card-text text-uppercase">Contacts</small>
                <ul className="list-unstyled my-3 py-1">
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-phone-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Contact:</span>{" "}
                    <span>{employeeData.mobile_no}</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-email-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Email:</span>{" "}
                    <span>{employeeData.email}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewEmployee;
